import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Button } from 'lib/cortiUI';
export const SaveAction = (props) => {
    const { t } = useTranslation('template', {
        keyPrefix: 'builder.configuration.thresholds.actions',
    });
    return (React.createElement(Button, Object.assign({}, props, { variant: "text" }), t('save', 'Save')));
};
